module.exports = __webpack_public_path__ + "img/pip-install-tuxmake.79de673a.svg";